const $$nested_directory$named_defaultExports = (function (exports) {
 
	
	function Ads(arg) { }
	
	class Cls { constructor() { } }
	
	console.log('>> named default export test attached');
	
	exports = { Ads, default:  Cls };
	
	return exports 
})({})